import './i18n'

import React from 'react'

export * from './styles'
export * from './Settings'
export * from './logger'
export * from './constants'
export * from './localStorage'
export * from './navigation'
export * from './api'
export * from './i18n'
export * from './packages'

export type { AppIcon } from './assets/icons'
export { iconImages } from './assets/icons'
import * as AppForms from './forms'
import * as AppImages from './assets/images'
import * as StyleSheets from './stylesheets'

export { default as licenses } from './license.json'
export { default as timestamp } from './timestamp.json'

export { textVariant } from './stylesheets/Text'

export {
  React,
  AppForms,
  AppImages,
  StyleSheets,
}
